// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Badge } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetAnwesenheitenBadge(): () => Promise<Badge> {
  const getAPI = useGetApi();
  return useCallback(
    async () => (await getAPI()).anwesenheiten.getAnwesenheitenBadge(),
    [getAPI]
  );
}
